import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import ReactDOM from "react-dom";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserData } from "./const";
import "../assets/css/theme-table-header.css";
import { getSessionBranchId } from "../utils/sessionBranch";
import { useIndiaStateCity } from "../utils/useIndiaStateCity";
import {
  addOldMetalPurchase,
  createCustomerUser,
  isErpApiSuccess,
  listBankAccounts,
  listBillTypes,
  listCustomerUsers,
  showCustomerUser,
  showOldMetalPurchaseById,
} from "../erpClient";
import {
  createOldMetalIdempotencyKey,
  isOldMetalApiSuccess,
} from "../utils/oldMetalPurchaseErpAdapter";
import { mapCustomerUsersToPartyList } from "../utils/customerUsersErpAdapter";
import { buildStandardPaymentLines, readUrdDocNumber } from "../utils/paymentLinesErpAdapter";
import { toast } from "react-hot-toast";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";
import CustomerSelection from "../components/CustomerSelection";
import PaymentSection, {
  PAYMENT_METHOD_LABELS,
} from "../components/PaymentSection";
import { getMobileValidationError } from "../utils/mobileInput";
import { getEmailValidationError } from "../utils/emailInput";
import { handleRoundOffInputChange } from "../utils/roundOffInput";
import { autoRoundOff } from "../utils/autoRoundOff";
import {
  defaultProductGroupForMetalType,
  mergeProductGroupOptions,
  searchProductGroupSelectOptions,
  productGroupOptionDisplayName,
  urdProductGroupLabelForMetalType,
} from "../utils/productGroupOptions";
import { numPool } from "../utils/productGroupPool";
import ProductGroupPoolBalance from "../components/ProductGroupPoolBalance";
import {
  setupPortalContainers,
  teardownPortalContainers,
} from "../utils/portalContainers";
import OldPurchaseTable from "../components/OldPurchaseTable";

const DEFAULT_BILL_LABEL = "GST";
// URD defaults to 0%; user enters GST % when needed
const DEFAULT_GST_PERCENT = "0";

const resolveBillTypeGstPercent = () => DEFAULT_GST_PERCENT;

const URD_EXCLUDED_PAY_MODES = ["old_gold", "old_silver", "kasar"];

const createDefaultSettlementRows = () => [
  {
    id: 1,
    pay_mode: "cash",
    type: "",
    remarks: "",
    amount: "",
  },
  {
    id: 2,
    pay_mode: "upi",
    type: "",
    remarks: "",
    amount: "",
  },
  {
    id: 3,
    pay_mode: "bank_transfer",
    type: "",
    remarks: "",
    amount: "",
  },
];

const parseNumericValue = (value) => {
  if (value === "" || value === null || value === undefined) return 0;
  const num = parseFloat(String(value).replace(/,/g, ""));
  return isNaN(num) ? 0 : num;
};

function AddOldPurchase({
  masterGoldRate = 0,
  masterSilverRate = 0,
  showLiveRate = false,
}) {
  const { buttonClass, tableClass, cardClass, buttonTableStyle } =
    useButtonTableStyle();
  const navigate = useNavigate();
  const location = useLocation();
  const saleFromState = location.state?.fromSale ? location.state : null;
  const isSilverMode = String(saleFromState?.metalType || "").toUpperCase() === "OLD_SILVER";
  const [selectedDate, setSelectedDate] = useState("");
  const [productGroupOptionsCache, setProductGroupOptionsCache] = useState([]);
  const [productGroupRowResults, setProductGroupRowResults] = useState({});
  const [productGroupSearchLoading, setProductGroupSearchLoading] = useState(
    {},
  );
  const [productGroupApiCalled, setProductGroupApiCalled] = useState({});
  const [productGroupDropdownActive, setProductGroupDropdownActive] =
    useState({});
  const [productGroupSearchText, setProductGroupSearchText] = useState({});
  const [productGroupHighlightedIndex, setProductGroupHighlightedIndex] =
    useState({});
  const productGroupInputRefs = useRef({});
  const productGroupDropdownRefs = useRef({});
  const productGroupItemsRefs = useRef({});
  const lastSearchedProductGroupPrefixRef = useRef({});
  const productGroupSearchTimerRef = useRef({});
  const [productGroupPoolHeader, setProductGroupPoolHeader] = useState(null);

  // Bill type states
  const [billTypes, setBillTypes] = useState([]);
  const [billTypeSearchText, setBillTypeSearchText] =
    useState(DEFAULT_BILL_LABEL);
  const [billTypeDropdownActive, setBillTypeDropdownActive] = useState(false);
  const [billTypeHighlightedIndex, setBillTypeHighlightedIndex] = useState(-1);
  const [billType, setBillType] = useState(null);
  const billTypeInputRef = useRef(null);
  const billTypeDropdownRef = useRef(null);
  const billTypeItemsRef = useRef([]);
  const billTypesLoadedRef = useRef(false);
  const billTypesLoadingRef = useRef(false);
  const customerSearchCacheRef = useRef(new Set());

  // Customer selection states (like Sales.jsx)
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerMobileSearchText, setCustomerMobileSearchText] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerNameSearchText, setCustomerNameSearchText] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [customerMobileDropdownActive, setCustomerMobileDropdownActive] =
    useState(false);
  const [customerNameDropdownActive, setCustomerNameDropdownActive] =
    useState(false);
  const [customerMobileHighlightedIndex, setCustomerMobileHighlightedIndex] =
    useState(0);
  const [customerNameHighlightedIndex, setCustomerNameHighlightedIndex] =
    useState(0);
  const customerMobileInputRef = useRef(null);
  const customerNameInputRef = useRef(null);
  const customerMobileDropdownRef = useRef(null);
  const customerNameDropdownRef = useRef(null);
  const customerMobileItemsRef = useRef([]);
  const customerNameItemsRef = useRef([]);
  const userData = getUserData();
  const [userss, setUserss] = useState([]);

  // Additional states needed by CustomerSelection component
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerCity, setCustomerCity] = useState("Ahmedabad"); // Default to Ahmedabad
  const [customerDetails, setCustomerDetails] = useState({
    email: "",
    birthDate: "",
    anniversaryDate: "",
    companyName: "",
    companyAddress: "",
    gstNumber: "",
    aadharNo: "",
    panNo: "",
    maritalStatus: "",
    balance: "",
    saleBalance: "",
    reference: "",
    state: "Gujarat", // Default to Gujarat
    area: "",
  });
  const { states, cities, selectedState, setSelectedState } =
    useIndiaStateCity("GJ");
  const [savingCustomer, setSavingCustomer] = useState(false);
  const [customerSaveSuccess, setCustomerSaveSuccess] = useState(false);
  const [tableRows, setTableRows] = useState([
    {
      id: 1,
      product_group_id: "",
      pcs: "",
      ct: "",
      gwt: "",
      lwt: "",
      nwt: "",
      touch: "",
      fine_wt: "",
      total_amt: "",
      isTotalAmtManual: false,
    },
  ]);

  const oldMetalCreateIdempotencyKeyRef = useRef(null);
  const oldMetalCreateFingerprintRef = useRef(null);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentRows, setPaymentRows] = useState(createDefaultSettlementRows);
  const [payableRows, setPayableRows] = useState([
    { id: 1, pay_mode: "cash", type: "", remarks: "", amount: "" },
  ]);
  const [note, setNote] = useState("");
  const [followUpDate, setFollowUpDate] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [roundOffAmount, setRoundOffAmount] = useState("");
  const [isManualRoundOff, setIsManualRoundOff] = useState(false);
  const [gstPercentage, setGstPercentage] = useState(DEFAULT_GST_PERCENT);
  const [customerState, setCustomerState] = useState("");

  // Fetch Bill Types lazily (not on pageload)
  const fetchBillTypes = async () => {
    if (billTypesLoadedRef.current && billTypes.length > 0) {
      return billTypes;
    }
    if (billTypesLoadingRef.current) {
      while (billTypesLoadingRef.current) {
        await new Promise((r) => setTimeout(r, 40));
      }
      return billTypes;
    }
    billTypesLoadingRef.current = true;
    try {
      const response = await listBillTypes();
      const rows = Array.isArray(response?.data?.bill_types)
        ? response.data.bill_types
        : [];
      if (response?.success && Array.isArray(rows)) {
        const fetchedItems = rows.map((billType) => ({
          id: billType.id,
          name: billType.name || "",
          label: billType.name || "",
          value: billType.id || "",
          applicable: billType.gst_applicable ?? 0,
          isGstApplicable: (billType.gst_applicable ?? 0) == 1,
          gstPercentage:
            billType.gst_percent !== undefined && billType.gst_percent !== null
              ? String(billType.gst_percent)
              : "0",
        }));

        fetchedItems.sort((a, b) => b.id - a.id);
        setBillTypes(fetchedItems);
        billTypesLoadedRef.current = true;
        return fetchedItems;
      }
      return [];
    } catch (error) {
      console.error("Error fetching bill types:", error);
      toast.error("Failed to fetch bill types");
      return [];
    } finally {
      billTypesLoadingRef.current = false;
    }
  };

  const ensureBillTypesLoaded = async () => fetchBillTypes();

  // Listen for API URL changes — clear caches; do not preload lists
  useEffect(() => {
    const handleApiUrlChange = (event) => {
      console.log(
        "API URL changed in AddOldPurchase, clearing cached lists...",
        event.detail,
      );
      billTypesLoadedRef.current = false;
      setBillTypes([]);
      setUserss([]);
      customerSearchCacheRef.current = new Set();
    };

    window.addEventListener("apiUrlChanged", handleApiUrlChange);

    return () => {
      window.removeEventListener("apiUrlChanged", handleApiUrlChange);
    };
  }, []);

  const applyBillTypeSelection = useCallback(
    (item) => {
      if (!item) return;
      setBillType(item.value);
      setBillTypeSearchText(item.label);
      setGstPercentage(resolveBillTypeGstPercent(item));
    },
    [setGstPercentage]
  );

  useEffect(() => {
    if (!billTypes.length) return;

    const currentSelection = billTypes.find((item) => item.value === billType);

    if (currentSelection) {
      setBillTypeSearchText(currentSelection.label);
      setGstPercentage(resolveBillTypeGstPercent(currentSelection));
      return;
    }

    const defaultItem =
      billTypes.find(
        (item) => item.label?.toLowerCase() === DEFAULT_BILL_LABEL.toLowerCase()
      ) || billTypes[0];

    if (defaultItem) {
      applyBillTypeSelection(defaultItem);
    }
  }, [billTypes, billType, applyBillTypeSelection]);

  useEffect(() => {
    if (!billTypes || billTypes.length === 0) return;

    const selectedBillType = billTypes.find(
      (item) =>
        item.label.toLowerCase() === billTypeSearchText.toLowerCase() ||
        item.value === billType
    );

    if (!selectedBillType) return;

    if (billType !== selectedBillType.value) {
      setBillType(selectedBillType.value);
      // Only sync GST when bill type itself changes — keep GST manually editable
      setGstPercentage(resolveBillTypeGstPercent(selectedBillType));
    }
  }, [billTypes, billTypeSearchText, billType]);

  // Set today's date as default
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setSelectedDate(today);
  }, []);

  // Fetch customers only when searching (not on pageload)
  const fetchUserss = useCallback(async (search = "") => {
    const searchText =
      search !== undefined && search !== null ? String(search).trim() : "";
    if (!searchText || searchText.length < 3) return [];

    try {
      const response = await listCustomerUsers({ search: searchText });
      const party = mapCustomerUsersToPartyList(response);
      if (party?.length) {
        setUserss((prev) => {
          const byId = new Map(
            (Array.isArray(prev) ? prev : []).map((u) => [String(u.id), u]),
          );
          party.forEach((u) => byId.set(String(u.id), u));
          return Array.from(byId.values()).sort((a, b) => b.id - a.id);
        });
        customerSearchCacheRef.current.add(searchText.toLowerCase());
        return party;
      }
      return [];
    } catch (error) {
      console.error("Error fetching users:", error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (selectedCustomerId) return;

    const nextSearch = [customerMobileSearchText, customerNameSearchText]
      .map((value) => (value ? String(value).trim() : ""))
      .find(
        (value) =>
          value.length >= 3 &&
          !customerSearchCacheRef.current.has(value.toLowerCase()),
      );

    if (!nextSearch) return;
    void fetchUserss(nextSearch);
  }, [
    customerMobileSearchText,
    customerNameSearchText,
    selectedCustomerId,
    fetchUserss,
  ]);

  const applyCustomerToForm = useCallback((customer) => {
    if (!customer?.id) return;
    setSelectedCustomerId(customer.id);
    setCustomerMobile(customer.mobile || "");
    setCustomerMobileSearchText(customer.mobile || "");
    setCustomerName(customer.fullName || customer.name || "");
    setCustomerNameSearchText(customer.fullName || customer.name || "");
    setCustomerAddress(customer.address || "");
    if (customer.city) setCustomerCity(customer.city);
    setCustomerDetails((prev) => ({
      ...prev,
      email: customer.email || prev.email || "",
      state: customer.state || prev.state || "",
      area: customer.area || prev.area || "",
      balance: customer.balance || prev.balance || "",
      saleBalance: customer.saleBalance || prev.saleBalance || "",
      aadharNo: customer.aadharNo || prev.aadharNo || "",
      panNo: customer.panNo || prev.panNo || "",
      birthDate: customer.birthDate || prev.birthDate || "",
      maritalStatus: customer.maritalStatus || prev.maritalStatus || "",
      anniversaryDate: customer.anniversaryDate || prev.anniversaryDate || "",
      companyName: customer.companyName || prev.companyName || "",
      companyAddress: customer.companyAddress || prev.companyAddress || "",
      gstNumber: customer.gstNumber || prev.gstNumber || "",
      reference: customer.reference || prev.reference || "",
    }));
    if (customer.state) setSelectedState(customer.state);
  }, [setSelectedState]);

  // Prefill customer from sale redirect (snapshot first; show API only for real ids)
  useEffect(() => {
    if (!saleFromState?.fromSale) return;

    const rawId = saleFromState.customerId ?? saleFromState.tempCustomerId;
    const numericId = Number(rawId);
    const isRealId =
      !saleFromState.isNewCustomer &&
      !String(rawId ?? "").startsWith("TEMP_") &&
      Number.isFinite(numericId) &&
      numericId > 0;

    const resolvedName = String(saleFromState.customerName || "").trim();
    const resolvedMobile = String(saleFromState.customerMobile || "").trim();

    if (!isRealId && !resolvedName && !resolvedMobile) return;

    const snapshotId = isRealId
      ? numericId
      : saleFromState.tempCustomerId ||
      (String(rawId ?? "").startsWith("TEMP_") ? rawId : `TEMP_${Date.now()}`);

    const snapshot = {
      id: snapshotId,
      fullName: resolvedName,
      name: resolvedName,
      mobile: resolvedMobile,
      address: saleFromState.customerAddress || "",
      city: saleFromState.customerCity || "",
      email: saleFromState.customerEmail || "",
      state: saleFromState.customerState || "",
      area: saleFromState.customerArea || "",
    };
    setUserss((prev) => {
      const byId = new Map(
        (Array.isArray(prev) ? prev : []).map((u) => [String(u.id), u]),
      );
      byId.set(String(snapshot.id), snapshot);
      return Array.from(byId.values());
    });
    applyCustomerToForm(snapshot);

    if (!isRealId) return;

    let cancelled = false;
    (async () => {
      try {
        const response = await showCustomerUser({ id: numericId });
        if (cancelled) return;
        const raw =
          response?.data?.customer ??
          response?.data?.user ??
          response?.data?.item ??
          (Array.isArray(response?.data?.customers)
            ? response.data.customers[0]
            : null) ??
          (Array.isArray(response?.data?.items)
            ? response.data.items[0]
            : null) ??
          (Array.isArray(response?.data) ? response.data[0] : null) ??
          response?.data;
        if (!isErpApiSuccess(response) || !raw?.id) return;

        const mapped = {
          id: raw.id,
          fullName: raw.name || "",
          name: raw.name || "",
          mobile: raw.mobile || "",
          email: raw.email || "",
          city: raw.city || "",
          address: raw.address || "",
          state: raw.state || "",
          area: raw.area || raw.Area || raw.area_name || raw.areaName || "",
          aadharNo: raw.aadhar_no || "",
          panNo: raw.pan_no || "",
          birthDate: raw.birth_date || "",
          maritalStatus: raw.marital_status || "",
          anniversaryDate: raw.anniversary_date || "",
          balance: raw.users_balance ?? raw.balance ?? "",
          saleBalance: raw.sale_balance || "",
          companyName: raw.company_name || "",
          companyAddress: raw.company_address || "",
          gstNumber: raw.GST_number || raw.gst_number || "",
          reference: raw.reference || "",
        };
        setUserss((prev) => {
          const byId = new Map(
            (Array.isArray(prev) ? prev : []).map((u) => [String(u.id), u]),
          );
          byId.set(String(mapped.id), mapped);
          return Array.from(byId.values());
        });
        applyCustomerToForm(mapped);
      } catch (error) {
        console.error("Error loading sale customer:", error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    saleFromState?.fromSale,
    saleFromState?.customerId,
    saleFromState?.tempCustomerId,
    saleFromState?.isNewCustomer,
    saleFromState?.customerName,
    saleFromState?.customerMobile,
    saleFromState?.customerAddress,
    saleFromState?.customerCity,
    saleFromState?.customerEmail,
    saleFromState?.customerState,
    saleFromState?.customerArea,
    applyCustomerToForm,
  ]);

  useEffect(() => {
    setupPortalContainers();
    return teardownPortalContainers;
  }, []);

  useEffect(() => {
    if (!saleFromState?.metalType) return;

    const metalType = saleFromState.metalType;
    const displayName = urdProductGroupLabelForMetalType(metalType);
    const firstRowId = 1;

    // Show Old Gold / Old Silver in the product column immediately
    if (displayName) {
      setProductGroupSearchText((prev) => ({
        ...prev,
        [firstRowId]: displayName,
      }));
    }

    let cancelled = false;

    (async () => {
      const searchTerms = [
        String(metalType).toUpperCase() === "OLD_SILVER" ? "OSL" : "OGD",
        displayName,
        displayName.toLowerCase(),
      ].filter(Boolean);

      try {
        let opts = [];
        for (const term of searchTerms) {
          opts = await searchProductGroupSelectOptions(term);
          if (cancelled) return;
          if (defaultProductGroupForMetalType(opts, metalType)) break;
        }
        if (cancelled) return;

        const defaultPg = defaultProductGroupForMetalType(opts, metalType);
        if (!defaultPg) return;

        const pgOption =
          opts.find((o) => String(o.value) === String(defaultPg)) || {
            value: defaultPg,
            id: defaultPg,
            name: displayName,
            label: displayName,
          };
        const label =
          productGroupOptionDisplayName(pgOption) || displayName || "";

        setProductGroupOptionsCache((prev) =>
          mergeProductGroupOptions(prev, [pgOption]),
        );
        setProductGroupRowResults((prev) => ({
          ...prev,
          [firstRowId]: [pgOption],
        }));
        setTableRows((prev) =>
          prev.map((row, idx) =>
            idx === 0
              ? { ...row, product_group_id: String(defaultPg) }
              : row,
          ),
        );
        setProductGroupSearchText((prev) => ({
          ...prev,
          [firstRowId]: label,
        }));
        applyPoolHeaderFromGroup(pgOption);
      } catch (e) {
        console.error("Error resolving default product group:", e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [saleFromState?.metalType]);

  const getProductGroupRowOptions = (rowId) =>
    productGroupRowResults[rowId] || [];

  const applyPoolHeaderFromGroup = (group) => {
    if (!group) {
      setProductGroupPoolHeader(null);
      return;
    }
    setProductGroupPoolHeader({
      pcs: numPool(group.pool_pcs),
      nwt: numPool(group.pool_nwt),
    });
  };

  const syncPoolHeaderForRow = (rowId) => {
    const options = getProductGroupRowOptions(rowId);
    if (productGroupDropdownActive[rowId] && options.length > 0) {
      const idx = productGroupHighlightedIndex[rowId] || 0;
      applyPoolHeaderFromGroup(options[idx]);
      return;
    }
    const row = tableRows.find((r) => String(r.id) === String(rowId));
    if (row?.product_group_id) {
      const cached = productGroupOptionsCache.find(
        (o) => String(o.value) === String(row.product_group_id),
      );
      applyPoolHeaderFromGroup(cached);
      return;
    }
    setProductGroupPoolHeader(null);
  };

  const fetchProductGroupByPrefix = useCallback(async (rowId, prefix) => {
    const trimmed = String(prefix || "").trim();
    if (trimmed.length < 3) {
      setProductGroupRowResults((prev) => ({ ...prev, [rowId]: [] }));
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: false }));
      return;
    }

    if (lastSearchedProductGroupPrefixRef.current[rowId] === trimmed) {
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: true }));
      return;
    }

    setProductGroupSearchLoading((prev) => ({ ...prev, [rowId]: true }));
    try {
      const opts = await searchProductGroupSelectOptions(trimmed);
      lastSearchedProductGroupPrefixRef.current[rowId] = trimmed;
      setProductGroupRowResults((prev) => ({ ...prev, [rowId]: opts }));
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: true }));
      if (opts.length > 0) {
        applyPoolHeaderFromGroup(opts[0]);
      }
    } catch (e) {
      console.error("Error searching product groups:", e);
      setProductGroupRowResults((prev) => ({ ...prev, [rowId]: [] }));
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: true }));
    } finally {
      setProductGroupSearchLoading((prev) => ({ ...prev, [rowId]: false }));
    }
  }, []);

  const handleProductGroupChange = (rowId, value) => {
    setProductGroupSearchText((prev) => ({ ...prev, [rowId]: value }));
    setProductGroupHighlightedIndex((prev) => ({ ...prev, [rowId]: 0 }));

    if (productGroupSearchTimerRef.current[rowId]) {
      clearTimeout(productGroupSearchTimerRef.current[rowId]);
    }

    if (!value.trim()) {
      handleTableRowChange(rowId, "product_group_id", "");
      setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));
      setProductGroupRowResults((prev) => ({ ...prev, [rowId]: [] }));
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: false }));
      lastSearchedProductGroupPrefixRef.current[rowId] = "";
      setProductGroupPoolHeader(null);
      return;
    }

    const hasMinChars = value.trim().length >= 3;
    setProductGroupDropdownActive((prev) => ({
      ...prev,
      [rowId]: hasMinChars,
    }));

    if (hasMinChars) {
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: false }));
      productGroupSearchTimerRef.current[rowId] = setTimeout(() => {
        fetchProductGroupByPrefix(rowId, value.trim());
      }, 300);
    } else {
      setProductGroupRowResults((prev) => ({ ...prev, [rowId]: [] }));
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: false }));
      lastSearchedProductGroupPrefixRef.current[rowId] = "";
    }
  };

  const handleProductGroupSelect = (rowId, selectedGroup) => {
    handleTableRowChange(rowId, "product_group_id", String(selectedGroup.value));
    setProductGroupSearchText((prev) => ({
      ...prev,
      [rowId]: selectedGroup.name || selectedGroup.label || "",
    }));
    setProductGroupOptionsCache((prev) =>
      mergeProductGroupOptions(prev, [selectedGroup]),
    );
    applyPoolHeaderFromGroup(selectedGroup);
    setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));

    const nextInput = productGroupInputRefs.current[rowId]
      ?.closest("tr")
      ?.querySelector('input[placeholder="0"]');
    if (nextInput) nextInput.focus();
  };

  const handleProductGroupKeyDown = (e, rowId) => {
    const filtered = getProductGroupRowOptions(rowId);

    if (
      !productGroupDropdownActive[rowId] ||
      filtered.length === 0 ||
      productGroupSearchLoading[rowId]
    ) {
      if (e.key === "Enter" || e.key === "Tab") {
        const nextInput = e.target
          .closest("tr")
          ?.querySelector('input[placeholder="0"]');
        if (nextInput) nextInput.focus();
      }
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setProductGroupHighlightedIndex((prev) => {
          const nextIdx = Math.min(
            (prev[rowId] || 0) + 1,
            filtered.length - 1,
          );
          applyPoolHeaderFromGroup(filtered[nextIdx]);
          return { ...prev, [rowId]: nextIdx };
        });
        break;
      case "ArrowUp":
        e.preventDefault();
        setProductGroupHighlightedIndex((prev) => {
          const nextIdx = Math.max((prev[rowId] || 0) - 1, 0);
          applyPoolHeaderFromGroup(filtered[nextIdx]);
          return { ...prev, [rowId]: nextIdx };
        });
        break;
      case "Enter":
        e.preventDefault();
        handleProductGroupSelect(
          rowId,
          filtered[productGroupHighlightedIndex[rowId] || 0],
        );
        break;
      case "Escape":
        setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));
        break;
      case "Tab":
        setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));
        break;
      default:
        break;
    }
  };

  const renderProductGroupDropdown = (rowId) => {
    if (!productGroupDropdownActive[rowId]) return null;

    const searchText = productGroupSearchText[rowId] || "";
    if (!searchText.trim() || searchText.trim().length < 3) return null;

    const filtered = getProductGroupRowOptions(rowId);
    const loading = productGroupSearchLoading[rowId];
    const apiCalled = productGroupApiCalled[rowId];

    const inputElement = productGroupInputRefs.current[rowId];
    if (!inputElement) return null;

    const inputRect = inputElement.getBoundingClientRect();
    if (!inputRect) return null;

    const inputWidth = inputElement.offsetWidth;
    const maxVisibleItems = 5;
    const scrollableHeight = maxVisibleItems * 40;

    return ReactDOM.createPortal(
      <div
        ref={(el) => (productGroupDropdownRefs.current[rowId] = el)}
        className="dropdown-menu show shadow-sm"
        style={{
          position: "fixed",
          top: `${inputRect.bottom}px`,
          left: `${inputRect.left}px`,
          width: `${Math.max(inputWidth, 200)}px`,
          minWidth: `${Math.max(inputWidth, 200)}px`,
          maxWidth: `${Math.max(inputWidth, 280)}px`,
          zIndex: 9999,
          border: "1px solid rgba(0,0,0,.15)",
          borderRadius: "0.25rem",
          padding: "0.5rem 0",
          backgroundColor: "#fff",
          fontSize: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        }}
      >
        <div
          style={{
            maxHeight: `${scrollableHeight}px`,
            overflowY:
              !loading && filtered.length > maxVisibleItems ? "auto" : "hidden",
            overflowX: "hidden",
          }}
        >
          {loading ? (
            <div
              className="dropdown-item text-muted"
              style={{ cursor: "default", padding: "0.5rem 1rem" }}
            >
              Searching...
            </div>
          ) : filtered.length > 0 ? (
            filtered.map((group, idx) => (
              <div
                key={group.value}
                ref={(el) => {
                  if (!productGroupItemsRefs.current[rowId]) {
                    productGroupItemsRefs.current[rowId] = [];
                  }
                  productGroupItemsRefs.current[rowId][idx] = el;
                }}
                className="dropdown-item"
                style={{
                  cursor: "pointer",
                  padding: "0.5rem 1rem",
                  fontSize: "0.85rem",
                  backgroundColor:
                    idx === (productGroupHighlightedIndex[rowId] || 0)
                      ? "var(--theme-primary)"
                      : "transparent",
                  color:
                    idx === (productGroupHighlightedIndex[rowId] || 0)
                      ? "#fff"
                      : "inherit",
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                }}
                onMouseEnter={() => {
                  setProductGroupHighlightedIndex((prev) => ({
                    ...prev,
                    [rowId]: idx,
                  }));
                  applyPoolHeaderFromGroup(group);
                }}
                onMouseDown={() => handleProductGroupSelect(rowId, group)}
              >
                {productGroupOptionDisplayName(group)}
              </div>
            ))
          ) : apiCalled ? (
            <div
              className="dropdown-item text-muted"
              style={{ cursor: "default", padding: "0.5rem 1rem" }}
            >
              No matching items
            </div>
          ) : null}
        </div>
      </div>,
      document.getElementById("dropdown-portal") || document.body,
    );
  };

  // Fetch bank accounts
  useEffect(() => {
    const fetchBankDetails = async () => {
      try {
        const response = await listBankAccounts();
        if (response?.success && Array.isArray(response.data?.bank_accounts)) {
          const fetchedBankDetails = response.data.bank_accounts.map((bank) => ({
            id: bank.id,
            bankName: bank.bank_name || "",
            accountHolder: bank.holder_name || "",
            accountType: bank.account_type || "",
            accountNumber: bank.account_number || "",
            ifscCode: bank.ifsc_code || "",
            branchName: bank.branch_name || "",
          }));
          setBankAccounts(fetchedBankDetails);
          setPaymentTypes(
            fetchedBankDetails.map((bank) => ({
              value: bank.id,
              label: bank.bankName || bank.accountNumber || `Bank ${bank.id}`,
            })),
          );
        } else {
          setBankAccounts([]);
          setPaymentTypes([]);
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
        setBankAccounts([]);
        setPaymentTypes([]);
      }
    };
    fetchBankDetails();
  }, []);

  // Calculate fine_wt
  const getRowMetalFlags = (row) => {
    const pg = productGroupOptionsCache.find(
      (o) => String(o.value) === String(row.product_group_id),
    );
    const metal = String(
      pg?.metal || pg?.name || pg?.label || "",
    ).toUpperCase();
    return {
      isGold: metal.includes("GOLD"),
      isSilver: metal.includes("SILVER"),
    };
  };

  const calculateFineWt = (nwt, touch) => {
    const nwtVal = parseNumericValue(nwt);
    const touchVal = parseNumericValue(touch);

    if (nwtVal > 0 && touchVal > 0) {
      return (nwtVal * (touchVal / 100)).toFixed(3);
    }
    return "0.000";
  };

  // Calculate total amount based on ct (carat) and fine_wt
  // If ct is provided:
  //   Gold: total_amt = (ct/24) * live_gold_rate_per_gram * fine_wt
  //   Silver: total_amt = (masterSilverRate * ct * fine_wt) / 999 / 1000
  // If ct is not provided, use touch: total_amt = (touch/100) * fine_wt * rate_per_gram
  // Note: when showLiveRate is ON, master rates are per 10g (gold) / 1000g (silver).
  // When showLiveRate is OFF, master rates are already per gram.
  const calculateTotalAmount = (row) => {
    const fineWt = parseNumericValue(row.fine_wt);
    const ct = parseNumericValue(row.ct);
    const touch = parseNumericValue(row.touch);

    // Need fine_wt for calculation
    if (!fineWt || fineWt === 0) {
      return "0.00";
    }

    // Determine metal type from selected product group
    const { isGold, isSilver } = getRowMetalFlags(row);

    if (!isGold && !isSilver) {
      return "0.00";
    }

    let total = 0;

    // Priority: If touch is provided, use touch; otherwise use ct
    // For Silver, when both are present, touch takes priority
    if (touch && touch > 0) {
      // Use touch formula: (touch/100) * fine_wt * rate_per_gram
      // When live rate is enabled, master rates are per 10g (gold) / 1000g (silver).
      // When live rate is disabled, master rates are already per gram.
      const goldRatePerGram = showLiveRate
        ? masterGoldRate / 10
        : masterGoldRate;
      const silverRatePerGram = showLiveRate
        ? masterSilverRate / 1000
        : masterSilverRate;
      const liveRatePerGram = isGold
        ? goldRatePerGram
        : isSilver
          ? silverRatePerGram
          : 0;
      total = (touch / 100) * fineWt * liveRatePerGram;
    } else if (ct && ct > 0) {
      // If touch is not provided, use ct (carat) for purity-based calculation
      if (isGold) {
        // Gold: (ct/24) * rate_per_gram * fine_wt
        const liveRatePerGram = showLiveRate
          ? masterGoldRate / 10
          : masterGoldRate;
        const purityRate = (ct / 24) * liveRatePerGram;
        total = purityRate * fineWt;
      } else if (isSilver) {
        // Silver: (ct/999) * rate_per_gram * fine_wt
        const liveRatePerGram = showLiveRate
          ? masterSilverRate / 1000
          : masterSilverRate;
        total = (liveRatePerGram * ct * fineWt) / 999;
      }
    }

    return total.toFixed(2);
  };

  // When live rates change (e.g. "live price" checkbox toggled), update totals
  // for rows that were not manually overridden.
  useEffect(() => {
    setTableRows((prev) =>
      prev.map((row) => {
        if (row.isTotalAmtManual) return row;
        const nextTotal = calculateTotalAmount(row);
        // Avoid unnecessary state churn when nothing changes
        if (String(row.total_amt ?? "") === String(nextTotal ?? "")) {
          return row;
        }
        return { ...row, total_amt: nextTotal };
      }),
    );
  }, [masterGoldRate, masterSilverRate, showLiveRate, productGroupOptionsCache]);

  // Update fine_wt when nwt or touch changes
  // Update total_amt when fine_wt, touch, ct, or product_group_id changes (only if not manually edited)
  // Auto-calculate NWT: if GWT is entered, set NWT = GWT; if LWT is entered, set NWT = GWT - LWT
  const handleTableRowChange = (id, field, value) => {
    setTableRows((prev) =>
      prev.map((row) => {
        if (row.id === id) {
          const updatedRow = { ...row, [field]: value };

          // Auto-calculate NWT based on GWT and LWT
          if (field === "gwt") {
            // When GWT is entered, set NWT = GWT
            const gwtVal = parseNumericValue(value);
            updatedRow.nwt = gwtVal > 0 ? gwtVal.toFixed(3) : "";
          } else if (field === "lwt") {
            // When LWT is entered, calculate NWT = GWT - LWT
            const gwtVal = parseNumericValue(updatedRow.gwt);
            const lwtVal = parseNumericValue(value);
            if (gwtVal > 0) {
              const nwtVal = gwtVal - lwtVal;
              updatedRow.nwt = nwtVal > 0 ? nwtVal.toFixed(3) : "0.000";
            }
          }

          // Auto-calculate fine_wt when nwt or touch changes
          if (
            field === "nwt" ||
            field === "touch" ||
            field === "gwt" ||
            field === "lwt"
          ) {
            updatedRow.fine_wt = calculateFineWt(
              updatedRow.nwt,
              updatedRow.touch
            );
          }

          // If total_amt is manually changed, mark it as manual and don't recalculate
          if (field === "total_amt") {
            updatedRow.isTotalAmtManual = true;
          } else {
            // If weights/fields change, reset manual flag and recalculate total_amt
            if (
              field === "fine_wt" ||
              field === "touch" ||
              field === "ct" ||
              field === "product_group_id" ||
              field === "nwt" ||
              field === "gwt" ||
              field === "lwt"
            ) {
              updatedRow.isTotalAmtManual = false;
              updatedRow.total_amt = calculateTotalAmount(updatedRow);
            }
          }

          return updatedRow;
        }
        return row;
      })
    );
  };

  const handleAddTableRow = () => {
    const newId = Math.max(...tableRows.map((r) => r.id), 0) + 1;
    setTableRows([
      ...tableRows,
      {
        id: newId,
        product_group_id: "",
        pcs: "",
        ct: "",
        gwt: "",
        lwt: "",
        nwt: "",
        touch: "",
        fine_wt: "",
        total_amt: "",
        isTotalAmtManual: false,
      },
    ]);
  };

  // Handle total_amt focus - add new row when focused
  const handleTotalAmtFocus = (rowId) => {
    // Check if this is the last row
    const isLastRow = rowId === tableRows[tableRows.length - 1].id;
    if (isLastRow) {
      // Add a new row
      handleAddTableRow();
    }
  };

  const handleRemoveTableRow = (id) => {
    if (tableRows.length > 1) {
      setTableRows((prev) => prev.filter((row) => row.id !== id));
    }
  };

  // Handle bill type input change
  const handleBillTypeChange = (e) => {
    setBillTypeSearchText(e.target.value);
    setBillTypeDropdownActive(true);
    setBillTypeHighlightedIndex(0);
    void ensureBillTypesLoaded();
  };

  const handleBillTypeFocus = () => {
    setBillTypeDropdownActive(true);
    void ensureBillTypesLoaded();
  };

  // Filter the bill types based on search input
  const getFilteredBillTypes = (searchText) => {
    if (!searchText) return billTypes;
    const searchLower = searchText.toLowerCase();
    return billTypes.filter((item) =>
      item.label.toLowerCase().includes(searchLower)
    );
  };

  // Handle selection of a bill type
  const handleBillTypeSelect = (selectedItem) => {
    applyBillTypeSelection(selectedItem);
    setBillTypeDropdownActive(false);
  };

  // Handle key navigation in bill type dropdown
  const handleBillTypeKeyDown = (e) => {
    const filtered = getFilteredBillTypes(billTypeSearchText);

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setBillTypeHighlightedIndex((prevIndex) => {
          const newIndex =
            prevIndex < filtered.length - 1 ? prevIndex + 1 : prevIndex;
          if (billTypeItemsRef.current[newIndex]) {
            billTypeItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "ArrowUp":
        e.preventDefault();
        setBillTypeHighlightedIndex((prevIndex) => {
          const newIndex = prevIndex > 0 ? prevIndex - 1 : 0;
          if (billTypeItemsRef.current[newIndex]) {
            billTypeItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "Enter":
        e.preventDefault();
        if (filtered.length > 0 && billTypeDropdownActive) {
          handleBillTypeSelect(filtered[billTypeHighlightedIndex]);
        }
        break;
      case "Escape":
        e.preventDefault();
        setBillTypeDropdownActive(false);
        break;
      case "Tab":
        setBillTypeDropdownActive(false);
        break;
      default:
        break;
    }
  };

  const renderBillTypeDropdown = () => {
    if (!billTypeDropdownActive) return null;

    const filtered = getFilteredBillTypes(billTypeSearchText);
    billTypeItemsRef.current = [];

    const inputRect = billTypeInputRef.current
      ? billTypeInputRef.current.getBoundingClientRect()
      : null;

    if (!inputRect) return null;

    const scrollY = window.scrollY || window.pageYOffset;
    const scrollX = window.scrollX || window.pageXOffset;

    const top = inputRect.top + inputRect.height + scrollY - 1;
    const left = inputRect.left + scrollX;

    return ReactDOM.createPortal(
      <div
        ref={billTypeDropdownRef}
        className="dropdown-menu show shadow-sm"
        style={{
          position: "fixed",
          top: `${top}px`,
          left: `${left}px`,
          width: `${inputRect.width}px`,
          minWidth: `${inputRect.width}px`,
          maxWidth: `${inputRect.width}px`,
          maxHeight: "150px",
          overflowY: "auto",
          zIndex: 9999,
          border: "1px solid rgba(0,0,0,.15)",
          borderRadius: "0.25rem",
          padding: "0.5rem 0",
          backgroundColor: "#fff",
          fontSize: "12px",
          lineHeight: "1.2",
        }}
      >
        {filtered.length > 0 ? (
          filtered.map((item, idx) => {
            const isSelected =
              item.label.toLowerCase() === billTypeSearchText.toLowerCase();

            return (
              <div
                key={idx}
                ref={(el) => (billTypeItemsRef.current[idx] = el)}
                className={`dropdown-item ${idx === billTypeHighlightedIndex ? "active" : ""
                  }`}
                style={{
                  cursor: "pointer",
                  padding: "0.25rem 1rem",
                  fontSize: "0.85rem",
                  backgroundColor:
                    idx === billTypeHighlightedIndex
                      ? "var(--theme-primary)"
                      : isSelected
                        ? "#f0f0f0"
                        : "transparent",
                  color: idx === billTypeHighlightedIndex ? "#fff" : "inherit",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  transition: "background-color 0.2s, color 0.2s",
                }}
                onMouseEnter={() => setBillTypeHighlightedIndex(idx)}
                onMouseDown={() => handleBillTypeSelect(item)}
              >
                {item.label}
              </div>
            );
          })
        ) : (
          <div className="dropdown-item disabled">No matching bill types</div>
        )}
      </div>,
      document.getElementById("dropdown-portal") || document.body
    );
  };

  useEffect(() => {
    function handleClickOutside(event) {
      // Handle bill type dropdown
      if (
        billTypeDropdownRef.current &&
        !billTypeDropdownRef.current.contains(event.target) &&
        billTypeInputRef.current &&
        !billTypeInputRef.current.contains(event.target)
      ) {
        setBillTypeDropdownActive(false);
      }

      Object.keys(productGroupDropdownActive).forEach((rowId) => {
        if (productGroupDropdownActive[rowId]) {
          const dropdownRef = productGroupDropdownRefs.current[rowId];
          const inputRef = productGroupInputRefs.current[rowId];
          if (
            dropdownRef &&
            !dropdownRef.contains(event.target) &&
            inputRef &&
            !inputRef.contains(event.target)
          ) {
            setProductGroupDropdownActive((prev) => ({
              ...prev,
              [rowId]: false,
            }));
          }
        }
      });
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [productGroupDropdownActive]);

  // Calculate totals
  const totalAmount = useMemo(() => {
    return tableRows.reduce(
      (sum, row) => sum + parseNumericValue(row.total_amt),
      0
    );
  }, [tableRows]);

  const settlementTotal = useMemo(() => {
    return paymentRows.reduce(
      (sum, row) => sum + parseNumericValue(row.amount),
      0
    );
  }, [paymentRows]);

  const payablePaidTotal = useMemo(() => {
    return payableRows.reduce(
      (sum, row) => sum + parseNumericValue(row.amount),
      0
    );
  }, [payableRows]);

  // Calculate GST amount based on percentage
  const calculateGstAmount = () => {
    if (!gstPercentage || isNaN(gstPercentage)) {
      return {
        total: 0,
        sgst: 0,
        cgst: 0,
        igst: 0,
      };
    }

    const gstRate = parseFloat(gstPercentage);
    const totalGstAmount = (totalAmount * gstRate) / 100;

    // Get the business state (you may need to replace this with your actual business state)
    const businessState = "Gujarat"; // Replace with your actual business state

    // Check if customer state matches business state (case-insensitive comparison)
    const isIntraStateTransaction =
      customerState &&
      customerState.toLowerCase() === businessState.toLowerCase();

    if (isIntraStateTransaction) {
      // For intra-state transactions, split GST into SGST and CGST
      const halfGstRate = gstRate / 2;
      const sgstAmount = (totalAmount * halfGstRate) / 100;
      const cgstAmount = (totalAmount * halfGstRate) / 100;

      return {
        total: totalGstAmount,
        sgst: sgstAmount,
        cgst: cgstAmount,
        igst: 0,
      };
    } else {
      // For inter-state transactions, apply full GST as IGST
      return {
        total: totalGstAmount,
        sgst: 0,
        cgst: 0,
        igst: totalGstAmount,
      };
    }
  };

  const amountBeforeRoundOff = totalAmount - calculateGstAmount().total;
  const getAutoPaymentRoundOff = () =>
    autoRoundOff(amountBeforeRoundOff).roundOff;
  const getEffectiveRoundOff = () => {
    if (isManualRoundOff) {
      return parseFloat(roundOffAmount) || 0;
    }
    return getAutoPaymentRoundOff();
  };
  const getDisplayRoundOff = () => {
    if (isManualRoundOff) {
      return roundOffAmount;
    }
    return getAutoPaymentRoundOff().toFixed(2);
  };

  const roundOff = getEffectiveRoundOff();
  const grandTotalValue = Math.max(0, amountBeforeRoundOff + roundOff);
  const totalPaidValue = settlementTotal;
  const payableAmountValue = Math.max(0, totalPaidValue - grandTotalValue);
  const remainingAmount =
    totalPaidValue > grandTotalValue
      ? Math.max(0, payableAmountValue - payablePaidTotal)
      : Math.max(0, grandTotalValue - totalPaidValue);

  // Handle round-off amount change (any edit locks manual mode)
  const handleRoundOffChange = (e) => {
    handleRoundOffInputChange(
      e,
      (value) => {
        setIsManualRoundOff(true);
        setRoundOffAmount(value);
      },
      {
        allowNegative: true,
        simple: true,
      },
    );
  };

  const handleSave = async () => {
    if (!selectedDate) {
      toast.error("Please select a date");
      return;
    }

    // Get customer ID from the selected customer
    const mobileToSearch = customerMobileSearchText || customerMobile;
    const mobileError = getMobileValidationError(mobileToSearch, {
      required: true,
    });
    if (mobileError) {
      toast.error(mobileError);
      return;
    }

    const emailError = getEmailValidationError(customerDetails?.email);
    if (emailError) {
      toast.error(emailError);
      return;
    }

    const nameToUse = customerNameSearchText || customerName;

    let selectedUser = userss.find(
      (c) => String(c.id) === String(selectedCustomerId)
    );

    // If customer not found by ID, try to find by mobile
    if (!selectedUser) {
      selectedUser = userss.find(
        (c) => String(c.mobile).trim() === String(mobileToSearch).trim()
      );
    }

    // If customer not found in existing list, check if we have enough details to create one
    if (!selectedUser && mobileToSearch && nameToUse) {
      // Create a temporary user object from the form state
      const tempId = `TEMP_${Date.now()}`;
      selectedUser = {
        id: tempId,
        mobile: mobileToSearch,
        fullName: nameToUse,
        name: nameToUse,
        email: customerDetails.email || "",
        state: customerDetails.state || "Gujarat",
        area: customerDetails.area || "",
        city: customerCity || "Ahmedabad",
        address: customerAddress || "",
        aadharNo: customerDetails.aadharNo || "",
        panNo: customerDetails.panNo || "",
        birthDate: customerDetails.birthDate || "",
        maritalStatus: customerDetails.maritalStatus || "",
        anniversaryDate: customerDetails.anniversaryDate || "",
        balance: customerDetails.balance || "",
        saleBalance: customerDetails.saleBalance || "",
        companyName: customerDetails.companyName || "",
        companyAddress: customerDetails.companyAddress || "",
        gstNumber: customerDetails.gstNumber || "",
        reference: customerDetails.reference || "",
      };
      // console.log("Created temporary user for submission:", selectedUser);
    }

    if (!selectedUser) {
      toast.error("Please select a customer");
      return;
    }

    // Validate table rows
    const validRows = tableRows.filter(
      (row) =>
        row.product_group_id &&
        (parseNumericValue(row.gwt) > 0 || parseNumericValue(row.pcs) > 0),
    );
    if (validRows.length === 0) {
      toast.error("Please add at least one line with product group and weight/pcs");
      return;
    }

    setIsSaving(true);

    try {
      // Calculate totals
      const totalGwt = validRows.reduce(
        (sum, row) => sum + parseNumericValue(row.gwt),
        0
      );
      const totalNwt = validRows.reduce(
        (sum, row) => sum + parseNumericValue(row.nwt),
        0
      );
      const totalFine = validRows.reduce(
        (sum, row) => sum + parseNumericValue(row.fine_wt),
        0
      );
      const totalAmt = validRows.reduce(
        (sum, row) => sum + parseNumericValue(row.total_amt),
        0
      );

      // Format items array (removed unused legacy `items` local variable)

      const paymentPersistKeys = [];
      const paymentsPayload = buildStandardPaymentLines(paymentRows, {
        isUpdate: false,
        paymentTypes,
        payModeLabels: PAYMENT_METHOD_LABELS,
        createKey: createOldMetalIdempotencyKey,
        persistKeys: paymentPersistKeys,
      });

      if (paymentPersistKeys.length > 0) {
        setPaymentRows((prev) => {
          const next = [...prev];
          paymentPersistKeys.forEach(({ rowId, key }) => {
            const idx = next.findIndex((r) => r.id === rowId);
            if (idx >= 0) {
              next[idx] = { ...next[idx], paymentIdempotencyKey: key };
            }
          });
          return next;
        });
      }

      // Calculate GST amounts
      const gstAmts = calculateGstAmount();

      // Calculate grand total (amount after GST + auto/manual round-off)
      const roundOff = getEffectiveRoundOff();
      const grandTotal = totalAmt - gstAmts.total + roundOff;

      // Check if this is a new customer (temp ID)
      const isNewCustomer =
        selectedUser.id &&
        String(selectedUser.id).toString().startsWith("TEMP_");

      let newUserData = [];
      let userIdToSend = selectedUser.id;

      if (isNewCustomer) {
        userIdToSend = null;
      }

      // Populate newUserData only if it's a new customer OR if customer details were updated
      if (isNewCustomer || customerSaveSuccess) {
        newUserData = [
          {
            name: selectedUser.name || selectedUser.fullName,
            mobile: selectedUser.mobile,
            email: selectedUser.email,
            city: selectedUser.city,
            address: selectedUser.address,
            aadhar_no: selectedUser.aadharNo,
            pan_no: selectedUser.panNo,
            birth_date: selectedUser.birthDate || "0000-00-00",
            marital_status: selectedUser.maritalStatus,
            anniversary_date: selectedUser.anniversaryDate || "0000-00-00",
            balance: selectedUser.balance,
            sale_balance: selectedUser.saleBalance,
            company_name: selectedUser.companyName,
            company_address: selectedUser.companyAddress,
            GST_number: selectedUser.gstNumber,
            reference: selectedUser.reference,
            state: selectedUser.state,
            area: selectedUser.area || "",
            status: "1",
          },
        ];
      }

      // Resolve customer_id (modular ERP requires numeric customer_id)
      let customerIdNum = null;
      if (isNewCustomer || userIdToSend == null || userIdToSend === "") {
        const u = newUserData && newUserData.length > 0 ? newUserData[0] : null;
        if (!u) {
          toast.error("Please enter customer details");
          setIsSaving(false);
          return;
        }
        const custRes = await createCustomerUser({
          name: u.name,
          mobile: String(u.mobile || "").trim(),
          email: u.email || undefined,
          city: u.city || undefined,
          address: u.address || undefined,
          state: u.state || undefined,
          area: u.area || undefined,
          aadhar_no: u.aadhar_no || undefined,
          pan_no: u.pan_no || undefined,
          birth_date: u.birth_date || undefined,
          marital_status: u.marital_status || undefined,
          anniversary_date: u.anniversary_date || undefined,
          company_name: u.company_name || undefined,
          company_address: u.company_address || undefined,
          gst_number: u.GST_number || undefined,
          reference: u.reference || undefined,
          balance: Number(u.balance) || 0,
        });
        if (!custRes?.success) {
          toast.error(custRes?.message || "Failed to create customer");
          setIsSaving(false);
          return;
        }
        customerIdNum = Number(
          custRes.data?.id ??
          custRes.data?.customer_id ??
          custRes.customer_id ??
          NaN,
        );
      } else {
        customerIdNum = Number(userIdToSend);
      }
      if (!Number.isFinite(customerIdNum) || customerIdNum <= 0) {
        toast.error("Invalid customer");
        setIsSaving(false);
        return;
      }

      const itemsPayload = validRows.map((row) => ({
        product_group_id: Number(row.product_group_id),
        pcs: parseNumericValue(row.pcs),
        ct: parseNumericValue(row.ct),
        gwt: parseNumericValue(row.gwt),
        lwt: parseNumericValue(row.lwt),
        nwt: parseNumericValue(row.nwt),
        touch: parseNumericValue(row.touch),
        fine_wt: parseNumericValue(row.fine_wt),
        total_amount: parseNumericValue(row.total_amt),
        image: null,
      }));

      const baseBody = {
        branch_id: getSessionBranchId(),
        customer_id: customerIdNum,
        date: selectedDate,
        discount: 0,
        tax_amount: Number(gstAmts.total.toFixed(2)) || 0,
        round_off: roundOff,
        grand_total: Number(grandTotal.toFixed(2)),
        notes: note?.trim() || null,
        items: itemsPayload,
        ...(paymentsPayload.length ? { payments: paymentsPayload } : null),
      };

      const fingerprint = JSON.stringify(baseBody);
      if (
        !oldMetalCreateIdempotencyKeyRef.current ||
        oldMetalCreateFingerprintRef.current !== fingerprint
      ) {
        oldMetalCreateIdempotencyKeyRef.current = createOldMetalIdempotencyKey();
        oldMetalCreateFingerprintRef.current = fingerprint;
      }

      const response = await addOldMetalPurchase({
        idempotency_key: oldMetalCreateIdempotencyKeyRef.current,
        ...baseBody,
      });

      if (isOldMetalApiSuccess(response)) {
        oldMetalCreateIdempotencyKeyRef.current = null;
        oldMetalCreateFingerprintRef.current = null;
        toast.success("URD Invoice saved successfully!");

        const urdDocId =
          response?.data?.old_metal_purchase_document_id ??
          response?.data?.id ??
          response?.old_metal_purchase_document_id ??
          response?.id;

        if (saleFromState?.fromSale && urdDocId) {
          let urdDocNumber = readUrdDocNumber(response?.data ?? response);

          if (!urdDocNumber) {
            try {
              const showResponse = await showOldMetalPurchaseById({
                id: urdDocId,
              });
              urdDocNumber = readUrdDocNumber(showResponse?.data ?? showResponse);
            } catch (fetchErr) {
              console.warn("Failed to fetch URD doc number", fetchErr);
            }
          }

          navigate(saleFromState.returnPath || "/sales", {
            state: {
              urdPayment: {
                urd_document_id: Number(urdDocId),
                amount: Number(grandTotal.toFixed(2)),
                payment_mode:
                  saleFromState.metalType === "OLD_SILVER"
                    ? "OLD_SILVER"
                    : "OLD_GOLD",
                paymentRowId: saleFromState.paymentRowId,
                urd_doc_number: urdDocNumber,
                customer_id: customerIdNum,
              },
              saleDraftKey: saleFromState.saleDraftKey,
            },
          });
          return;
        }

        navigate("/metalpurchasetable");

        // Reset form
        setSelectedDate(new Date().toISOString().split("T")[0]);
        setCustomerMobile("");
        setCustomerMobileSearchText("");
        setCustomerName("");
        setCustomerNameSearchText("");
        setSelectedCustomerId(null);
        setTableRows([
          {
            id: 1,
            product_group_id: "",
            pcs: "",
            ct: "",
            gwt: "",
            lwt: "",
            nwt: "",
            touch: "",
            fine_wt: "",
            total_amt: "",
            isTotalAmtManual: false,
          },
        ]);
        setPaymentRows(createDefaultSettlementRows());
        setPayableRows([
          { id: 1, pay_mode: "cash", type: "", remarks: "", amount: "" },
        ]);
        setNote("");
        setFollowUpDate("");
        setRoundOffAmount("");
        setIsManualRoundOff(false);
        setBillType(null);
        setBillTypeSearchText(DEFAULT_BILL_LABEL);
        setGstPercentage(DEFAULT_GST_PERCENT);
        setCustomerState("");
      } else {
        toast.error(response?.message || "Failed to save URD Invoice");
      }
    } catch (error) {
      console.error("Error saving URD Invoice:", error);
      const status = error?.response?.status;
      if (status === 403) toast.error("No permission");
      else
        toast.error(
          error?.response?.data?.message ||
          error.message ||
          "Failed to save URD Invoice",
        );
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={`body-wrapper ${cardClass}`}>
      <div className="container-fluid">
        <div className={`card shadow-sm ${cardClass}`}>
          <div className="px-4 py-3 border-bottom">
            <div className="d-flex align-items-center flex-wrap gap-5 w-100">
              <h4 className="card-title mb-0">Add Old Purchase</h4>

              {/* Date Component */}
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="d-flex align-items-center">
                  <label
                    className="form-label me-2 mb-0"
                    style={{
                      width: "50px",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                    }}
                  >
                    Date:
                  </label>
                  <input
                    type="date"
                    className={`form-control form-control-sm ${buttonClass}`}
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    style={{ fontSize: "0.85rem" }}
                  />
                </div>
              </div>

              <ProductGroupPoolBalance balance={productGroupPoolHeader} />
            </div>
          </div>
          <div className="card-body">
            <CustomerSelection
              customerMobile={customerMobile}
              setCustomerMobile={setCustomerMobile}
              customerMobileSearchText={customerMobileSearchText}
              setCustomerMobileSearchText={setCustomerMobileSearchText}
              customerName={customerName}
              setCustomerName={setCustomerName}
              customerNameSearchText={customerNameSearchText}
              setCustomerNameSearchText={setCustomerNameSearchText}
              customerAddress={customerAddress}
              setCustomerAddress={setCustomerAddress}
              customerDetails={customerDetails}
              setCustomerDetails={setCustomerDetails}
              customerCity={customerCity}
              setCustomerCity={setCustomerCity}
              selectedCustomerId={selectedCustomerId}
              setSelectedCustomerId={setSelectedCustomerId}
              customerSaveSuccess={customerSaveSuccess}
              setCustomerSaveSuccess={setCustomerSaveSuccess}
              users={userss}
              setUsers={setUserss}
              states={states}
              cities={cities}
              selectedState={selectedState}
              setSelectedState={setSelectedState}
              buttonClass={buttonClass}
              savingCustomer={savingCustomer}
              readOnlyCustomerFields={Boolean(saleFromState)}
              hideAddButton={Boolean(saleFromState)}
            />

            <div className="mt-3">
              <OldPurchaseTable
                tableRows={tableRows}
                setTableRows={setTableRows}
                productGroupOptionsCache={productGroupOptionsCache}
                setProductGroupOptionsCache={setProductGroupOptionsCache}
                masterGoldRate={masterGoldRate}
                masterSilverRate={masterSilverRate}
                showLiveRate={showLiveRate}
                isSilverMode={isSilverMode}
                onPoolHeaderChange={applyPoolHeaderFromGroup}
                portalZIndex={9999}
                cardClass={cardClass}
                buttonTableStyle={buttonTableStyle}
                tableClass={`table-hover theme-header-table ${tableClass}`}
                buttonClass={buttonClass}
              />
            </div>

            <PaymentSection
              paymentRows={paymentRows}
              onPaymentRowsChange={setPaymentRows}
              paymentTypes={paymentTypes}
              bankAccounts={bankAccounts}
              excludedPayModes={URD_EXCLUDED_PAY_MODES}
              showCashPaid={false}
              payableRows={payableRows}
              onPayableRowsChange={setPayableRows}
              note={note}
              onNoteChange={setNote}
              showDiscount={false}
              finalAmount={totalAmount.toFixed(2)}
              gstPercentage={gstPercentage}
              onGstPercentageChange={setGstPercentage}
              gstAmount={calculateGstAmount().total.toFixed(2)}
              roundOffAmount={getDisplayRoundOff()}
              onRoundOffChange={handleRoundOffChange}
              grandTotal={grandTotalValue.toFixed(2)}
              totalPaid={totalPaidValue.toFixed(2)}
              payableAmount={payableAmountValue.toFixed(2)}
              remainingAmount={remainingAmount.toFixed(2)}
              followUpDate={followUpDate}
              onFollowUpDateChange={setFollowUpDate}
              buttonClass={buttonClass}
              cardClass={cardClass}
              buttonTableStyle={buttonTableStyle}
            />

            {/* Submit button at the bottom */}
            <div className="row mt-4">
              <div className="col-12">
                <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
                  <Button
                    variant="primary"
                    className={buttonClass}
                    onClick={handleSave}
                    disabled={isSaving}
                  >
                    {isSaving ? "Saving..." : "Save"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddOldPurchase;
